<template>
    <section class="py-5 bg-light">
      <CContainer>
        <h2 class="text-center mb-4">Featured Courses</h2>
        <CRow>
          <CCol md="4" v-for="(course, index) in courses" :key="index" class="mb-4">
            <CCard class="h-100">
              <CCardBody>
                <h5>{{ course.name }}</h5>
                <p>{{ course.summary }}</p>
                <CButton color="primary" size="sm">View Course</CButton>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        courses: [
          { name: "FlyHigh Learning Kit", summary: "Engaging and complete materials for PT3 & SPM." },
          { name: "Combo Pack", summary: "Best value bundles with savings and bonuses." },
          { name: "Solo Plan", summary: "Pick exactly what you need and pay as you go." }
        ]
      }
    }
  }
  </script>